import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../_core/_services/auth.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormatService } from '../../_core/_services/format';
import { ApiService } from '../../_core/_services/api.service';
import { AddCurrencyCountry, CountryCurrencyDto, CountryDto, CreateCountry } from '../../_core/_model/countries';
import { CurrencyDetailsDto } from '../../_core/_model/currency';
import { ApiMeta } from '../../_core/_model/api-response';
import { Modal, Tab } from 'bootstrap';
import { NotificationService } from '../../_core/_services/notification.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-countries',
  standalone: false,
  templateUrl: './countries.html',
  styleUrl: './countries.css',
})
export class Countries implements OnInit {
  countries: CountryDto[] = [];
  meta: ApiMeta | null = null;
  selectedCurrencyCountry: CountryCurrencyDto[] = [];
  metaCurrencyCountry: ApiMeta | null = null;
  loading = false;

  editModal?: Modal;
  loadingEdit = false;
  loadingCurrencyAssignment = false;
  savingCurrencyAssignment = false;
  assignmentCurrencies: CurrencyDetailsDto[] = [];
  showCurrencyAssignmentTab = false;
  loadingCountryCurrencies = false;

  countryPage: number = 1;
  currencyCountryPage: number = 1;

  selectedCountry?: CountryDto | null = null;
  private countryModal?: Modal;

  countryForm: FormGroup;
  editCountryForm: FormGroup;
  currencyAssignmentForm: FormGroup;
  
  deletingId: string | null = null;
  url: any;

  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private format: FormatService,
    private notifyService: NotificationService,
    private router: Router,
  ) {
    this.countryForm = this.fb.group({
      name: ['', Validators.required],
      code: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
      dialCode: ['', [Validators.required, Validators.pattern(/^\+[1-9]\d{0,3}$/)]],
      phoneNumberMinLength: [10, [Validators.required, Validators.min(4), Validators.max(15)]],
      phoneNumberMaxLength: [10, [Validators.required, Validators.min(4), Validators.max(15)]],
      phoneNumberFormat: ['3,3,4', [Validators.required, Validators.pattern(/^\d+(,\d+)*$/)]],
      phoneNumberPlaceholder: ['', Validators.required],
      removeNationalPrefixZero: [false],
      withdrawalFeePercentage: [0, [Validators.required, Validators.min(0)]],
      depositFeePercentage: [0, [Validators.required, Validators.min(0)]],
    });
    this.editCountryForm = this.fb.group({
      id: [''],
      name: ['', Validators.required],
      dialCode: ['', [Validators.required, Validators.pattern(/^\+[1-9]\d{0,3}$/)]],
      phoneNumberMinLength: [10, [Validators.required, Validators.min(4), Validators.max(15)]],
      phoneNumberMaxLength: [10, [Validators.required, Validators.min(4), Validators.max(15)]],
      phoneNumberFormat: ['3,3,4', [Validators.required, Validators.pattern(/^\d+(,\d+)*$/)]],
      phoneNumberPlaceholder: ['', Validators.required],
      removeNationalPrefixZero: [false],
      withdrawalFeePercentage: [0, [Validators.required, Validators.min(0)]],
      depositFeePercentage: [0, [Validators.required, Validators.min(0)]],
    });
    this.currencyAssignmentForm = this.fb.group({
      currencyCode: ['', Validators.required],
    });
    this.url = this.router.url.slice(1);
  }
  get name() { return this.countryForm.get('name'); }
  get code() { return this.countryForm.get('code'); }
  get dialCode() { return this.countryForm.get('dialCode'); }
  get phoneNumberMinLength() { return this.countryForm.get('phoneNumberMinLength'); }
  get phoneNumberMaxLength() { return this.countryForm.get('phoneNumberMaxLength'); }
  get phoneNumberFormat() { return this.countryForm.get('phoneNumberFormat'); }
  get phoneNumberPlaceholder() { return this.countryForm.get('phoneNumberPlaceholder'); }
  get withdrawalFeePercentage() { return this.countryForm.get('withdrawalFeePercentage'); }
  get depositFeePercentage() { return this.countryForm.get('depositFeePercentage'); }

  get editName() { return this.editCountryForm.get('name'); }
  get editDialCode() { return this.editCountryForm.get('dialCode'); }
  get editPhoneNumberMinLength() { return this.editCountryForm.get('phoneNumberMinLength'); }
  get editPhoneNumberMaxLength() { return this.editCountryForm.get('phoneNumberMaxLength'); }
  get editPhoneNumberFormat() { return this.editCountryForm.get('phoneNumberFormat'); }
  get editPhoneNumberPlaceholder() { return this.editCountryForm.get('phoneNumberPlaceholder'); }
  get editWithdrawalFeePercentage() { return this.editCountryForm.get('withdrawalFeePercentage'); }
  get editDepositFeePercentage() { return this.editCountryForm.get('depositFeePercentage'); }
  get assignmentCurrencyCode() { return this.currencyAssignmentForm.get('currencyCode'); }
  get currencyAssignmentLabel() {
    return this.selectedCurrencyCountry.length ? 'Change Currency' : 'Add Currency';
  }

  ngOnInit(): void {
    this.listCountries(this.countryPage);
  }

  listCountries(page:number) {
    this.loading = true;
    this.api.getCountries(page).subscribe({
      next: (res) => {
        this.meta = res.meta;
        this.countries = res.data || [];
      },
      error: (err) => {
        this.notifyService.showError(err.error?.Error?.Details || 'Failed to load countries', "Error");
      },
      complete: () => (this.loading = false),
    });
  }

  openCountryModal(country: CountryDto) {
    this.selectedCountry = country;
    this.selectedCurrencyCountry = [];
    this.metaCurrencyCountry = null;
    this.assignmentCurrencies = [];
    this.showCurrencyAssignmentTab = false;
    this.currencyAssignmentForm.reset({ currencyCode: '' });

    const el = document.getElementById('countryDetailsModal');
    if (!el) return;

    this.getCurrencyCountry(1);

    this.countryModal = Modal.getOrCreateInstance(el);
    this.countryModal.show();

    setTimeout(() => {
      const tab = document.getElementById('countryDetailsTabButton');
      if (tab) Tab.getOrCreateInstance(tab).show();
    });
  }

  getCurrencyCountry(page:number) {
    if (!this.selectedCountry) return;

    const countryCode = this.selectedCountry.code;
    this.selectedCurrencyCountry = [];
    this.metaCurrencyCountry = null;
    this.loadingCountryCurrencies = true;

    this.api.getCurrencyCountry(countryCode, page)
      .pipe(finalize(() => {
        if (this.selectedCountry?.code === countryCode) {
          this.loadingCountryCurrencies = false;
        }
      }))
      .subscribe({
      next: (res) => {
        if (this.selectedCountry?.code !== countryCode) return;

        this.metaCurrencyCountry = res.meta
        this.selectedCurrencyCountry = res.data || [];
      },
      error: (err) => {
        if (this.selectedCountry?.code !== countryCode) return;

        this.notifyService.showError(err.error?.Error?.Details || 'Failed to load country currency', "Error");
      },
    });
  }

  closeCountryModal() {
    this.countryModal?.hide();
    this.selectedCountry = null;
    this.selectedCurrencyCountry = [];
    this.metaCurrencyCountry = null;
    this.assignmentCurrencies = [];
    this.loadingCountryCurrencies = false;
    this.showCurrencyAssignmentTab = false;
    this.currencyAssignmentForm.reset({ currencyCode: '' });
  }

  openCurrencyAssignmentTab() {
    if (!this.selectedCountry) return;

    const countryCode = this.selectedCountry.code;
    this.currencyAssignmentForm.reset({ currencyCode: '' });
    this.showCurrencyAssignmentTab = true;

    this.loadingCurrencyAssignment = true;
    this.assignmentCurrencies = [];

    this.api.getCurrencies(1, 1000)
      .pipe(finalize(() => (this.loadingCurrencyAssignment = false)))
      .subscribe({
      next: (res) => {
        this.assignmentCurrencies = res.data || [];
      },
      error: (err) => {
        this.notifyService.showError(
          err.error?.Error?.Details || 'Failed to load currencies',
          'Error'
        );
      },
    });

    this.api.getCurrencyCountry(countryCode, 1, 1000).subscribe({
      next: (res) => {
        if (this.selectedCountry?.code !== countryCode) return;

        this.selectedCurrencyCountry = res.data || [];
        this.metaCurrencyCountry = res.meta;
      },
      error: (err) => {
        if (this.selectedCountry?.code !== countryCode) return;

        this.notifyService.showError(
          err.error?.Error?.Details || 'Unable to check assigned currencies',
          'Error'
        );
      },
    });

    setTimeout(() => {
      const tab = document.getElementById('currencyAssignmentTabButton');
      if (tab) Tab.getOrCreateInstance(tab).show();
    });
  }

  returnToCurrencyTab() {
    this.currencyAssignmentForm.reset({ currencyCode: '' });

    const tab = document.getElementById('currencyTabButton');
    if (tab) Tab.getOrCreateInstance(tab).show();
  }

  assignCurrencyToCountry() {
    if (!this.selectedCountry || this.currencyAssignmentForm.invalid) {
      this.currencyAssignmentForm.markAllAsTouched();
      return;
    }

    if (this.isCurrencyAssigned(this.assignmentCurrencyCode?.value)) {
      this.notifyService.showError('This currency is already assigned to the country.', 'Error');
      return;
    }

    const payload: AddCurrencyCountry = {
      countryCode: this.selectedCountry.code,
      currencyCode: this.assignmentCurrencyCode?.value,
    };

    this.savingCurrencyAssignment = true;
    this.api.addCurrencyCountry(payload).subscribe({
      next: (res) => {
        if (res.data) {
          this.selectedCurrencyCountry = [...this.selectedCurrencyCountry, res.data];
        }
        this.notifyService.showSuccess(
          `${payload.currencyCode} added to ${this.selectedCountry?.name}`,
          'Success'
        );
        this.returnToCurrencyTab();
      },
      error: (err) => {
        this.notifyService.showError(
          err.error?.Error?.Details || 'Failed to add currency to country',
          'Error'
        );
      },
      complete: () => (this.savingCurrencyAssignment = false),
    });
  }

  isCurrencyAssigned(currencyCode: string | null | undefined): boolean {
    if (!currencyCode) return false;

    return this.selectedCurrencyCountry.some(
      item => item.currency.code.toUpperCase() === currencyCode.toUpperCase()
    );
  }

  editCountry(country: CountryDto) {

    // populate
    this.editCountryForm.patchValue({
      id: country.id,
      name: country.name,
      dialCode: country.dialCode || '',
      phoneNumberMinLength: country.phoneNumberMinLength ?? 10,
      phoneNumberMaxLength: country.phoneNumberMaxLength ?? 10,
      phoneNumberFormat: country.phoneNumberFormat || '3,3,4',
      phoneNumberPlaceholder: country.phoneNumberPlaceholder || '',
      removeNationalPrefixZero: country.removeNationalPrefixZero,
      withdrawalFeePercentage: country.withdrawalFeePercentage,
      depositFeePercentage: country.depositFeePercentage
    });

    // show modal
    const el = document.getElementById('editCountryModal');
    if (!el) return;

    this.editModal = Modal.getOrCreateInstance(el);
    this.editModal.show();
  }


  closeEditModal() {
    this.editModal?.hide();
  }

  saveCountryEdits() {
    if (this.editCountryForm.invalid || !this.isPhoneMetadataValid(this.editCountryForm)) {
      this.editCountryForm.markAllAsTouched();
      return;
    }
    
    const updatedCountry = this.editCountryForm.getRawValue(); 

    this.loadingEdit = true;

    this.api.updateCountry(updatedCountry).subscribe({
      next: (res) => {
        const index = this.countries.findIndex(c => c.id === updatedCountry.id);
        if (index !== -1) {
          this.countries[index] = res.data!;
        }
        this.notifyService.showSuccess('Country updated successfully', "Success");
        this.closeEditModal();
      },
      error: (err) => {
        this.notifyService.showError(err.error?.Error?.Details || 'Failed to update country', "Error");
        alert(err.error?.Error?.Details || 'Failed to update country');
      },
      complete: () => (this.loadingEdit = false),
    }); 
  }

  deleteCountryCurrency(selectedCurrencyCountry: CountryCurrencyDto) {

    if (confirm(`Are you sure you want to delete ${selectedCurrencyCountry?.currency.name}? This action cannot be undone.`)) {
      this.api.deleteCountryCurrency(selectedCurrencyCountry!.id).subscribe({
        next: () => {
          this.selectedCurrencyCountry = this.selectedCurrencyCountry.filter(c => c.id !== selectedCurrencyCountry!.id);
          this.notifyService.showSuccess('Currency country deleted', 'Success');
        },
        error: (err) => {
          this.notifyService.showError(err.error?.Error?.Details || 'Failed to delete country currency', 'Error');
        }
      });
    }
  }

  deleteCountry(countryId: string) {
    const country = this.countries.find(c => c.id === countryId);
    this.deletingId = country!.id;

    if (confirm(`Are you sure you want to delete ${country?.name}? This action cannot be undone.`)) {
      this.api.deleteCountry(country!.id).subscribe({
        next: () => {
          this.countries = this.countries.filter(c => c.id !== country!.id);
          this.notifyService.showSuccess('Country deleted', 'Success');
        },
        error: (err) => {
          this.notifyService.showError(err.error?.Error?.Details || 'Failed to delete country', 'Error');
        }
      });
    }
  }

  addCountry() {
    if (this.countryForm.invalid || !this.isPhoneMetadataValid(this.countryForm)) {
      this.countryForm.markAllAsTouched();
      return;
    }

    const newCountry: CreateCountry = {
      name: this.name?.value,
      code: this.code?.value.toUpperCase(),
      dialCode: this.dialCode?.value.trim(),
      phoneNumberMinLength: Number(this.phoneNumberMinLength?.value),
      phoneNumberMaxLength: Number(this.phoneNumberMaxLength?.value),
      phoneNumberFormat: this.phoneNumberFormat?.value.trim(),
      phoneNumberPlaceholder: this.phoneNumberPlaceholder?.value.trim(),
      removeNationalPrefixZero: !!this.countryForm.get('removeNationalPrefixZero')?.value,
      withdrawalFeePercentage: this.withdrawalFeePercentage?.value,
      depositFeePercentage: this.depositFeePercentage?.value
    };

    this.api.createCountry(newCountry).subscribe({
      next: (res) => {
        this.countries.push(res.data!);
        this.countryForm.reset({
          name: '',
          code: '',
          dialCode: '',
          phoneNumberMinLength: 10,
          phoneNumberMaxLength: 10,
          phoneNumberFormat: '3,3,4',
          phoneNumberPlaceholder: '',
          removeNationalPrefixZero: false,
          withdrawalFeePercentage: 0,
          depositFeePercentage: 0
        });
        this.notifyService.showSuccess("Country added successfully", "Success")
      },
      error: (err) => {
        this.notifyService.showError(err.error?.Error?.Details || 'Failed to create country', "Error");
      }
    });
  }

  countryFlag(countryCode: string): string {
    const code = countryCode.trim().toUpperCase();
    if (!/^[A-Z]{2}$/.test(code)) return '🌐';

    return String.fromCodePoint(
      ...Array.from(code).map(character => 127397 + character.charCodeAt(0))
    );
  }

  private isPhoneMetadataValid(form: FormGroup): boolean {
    const minimum = Number(form.get('phoneNumberMinLength')?.value);
    const maximum = Number(form.get('phoneNumberMaxLength')?.value);
    const groups = String(form.get('phoneNumberFormat')?.value || '')
      .split(',')
      .map(value => Number(value.trim()));

    if (maximum < minimum) {
      this.notifyService.showError(
        'Maximum phone digits cannot be less than minimum phone digits.',
        'Validation'
      );
      return false;
    }

    const dialDigits = String(form.get('dialCode')?.value || '').replace(/\D/g, '').length;
    if (dialDigits + maximum > 15) {
      this.notifyService.showError(
        'Dial code and maximum national phone digits cannot exceed 15 digits.',
        'Validation'
      );
      return false;
    }

    if (!groups.length || groups.some(value => !Number.isInteger(value) || value <= 0)) {
      this.notifyService.showError(
        'Phone display format must contain positive comma-separated groups, for example 3,3,4.',
        'Validation'
      );
      return false;
    }

    if (groups.reduce((total, value) => total + value, 0) !== maximum) {
      this.notifyService.showError(
        'Phone display format groups must add up to the maximum phone digits.',
        'Validation'
      );
      return false;
    }

    return true;
  }

  getStatusClass(status: string): string {
    return this.format.getGeneralStatusClass(status, true);
  }
}
